
import { useLogger } from '@booksy-com/vue-tools'
import { path } from 'ramda'
import { isConfiguredBusiness, isPromise } from '@/lib/helpers.js'
import { TOKEN_ACTIONS } from './utils/consts.js'
import { useCore } from '@/composables/core/index.js'
import { useWebViewEventBus } from '@/composables/web-view-event-bus/index.js'

import NativeIdentity from './utils/native-identity.js'

const logger = useLogger('native-identity')

let nativeIdentity = null

export const createNativeIdentity = () => {
  if (nativeIdentity) {
    logger.error('native identity service already initialized')
    return
  }

  const { apiCall, store } = useCore()
  const { mode } = store.state.app

  nativeIdentity = new NativeIdentity({
    apiCall,
    getToken: () => {
      const nativeToken = localStorage.getItem('dev.native-token')

      if (mode === 'development' && nativeToken) {
        return Promise.resolve(nativeToken)
      }

      const { events } = useWebViewEventBus()
      return events.pushToken()
    },
    logger,
  })
}

const login = () => {
  return Promise.all([
    _registerToken(),
    _sendAuthLogin(),
  ])
}

const logout = () => {
  return Promise.all([
    _clearToken(),
    _sendAuthLogout(),
  ])
}

const _registerToken = () => {
  return _tokenAction(TOKEN_ACTIONS.REGISTER)
}

const _clearToken = () => {
  return _tokenAction(TOKEN_ACTIONS.CLEAR)
}

const _sendAuthLogin = () => {
  const { store } = useCore()
  const { identity } = store.state
  const email = path(['user', 'email'], identity)

  const { events } = useWebViewEventBus()
  return events.authLogin({ email })
}

const _sendAuthLogout = () => {
  const { events } = useWebViewEventBus()
  return events.authLogout()
}

const _tokenAction = (action) => {
  try {
    const { store } = useCore()
    const { business } = store.state.business
    const { webView } = store.state.app

    const result = nativeIdentity.tokenAction({
      action,
      business,
      webView,
    })

    if (isPromise(result)) {
      return result
    }

    throw new Error('Token action result is not a promise')
  } catch (e) {
    logger.error(e)
    return Promise.reject(e)
  }
}

const isAvailable = () => {
  const { store } = useCore()
  const isIOS = store.getters['app/isIOS']
  const isAndroid = store.getters['app/isAndroid']
  const isTablet = store.getters['app/isTablet']
  const { business } = store.state.business

  return (isIOS || isAndroid) && isTablet && isConfiguredBusiness(business)
}

export const useNativeIdentityService = () => {
  return {
    login,
    logout,
    isAvailable,
  }
}
